import React from "react";
import adelaide from "@/assets/images/adelaide.jpg";
import kitchen from "@/assets/images/kitchen.jpg";
import pyrotech from "@/assets/images/pyrotech.jpg";
import matt1 from "@/assets/images/mattPhoto1.png";

import photoReactjs from "@/assets/images/reactjs.jpg";

import techPhoto from "@/assets/images/techPhoto.jpg";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/20/solid";

const timelineEvents = [
  {
    year: "2023/07 - Now",
    description: "Freelance Frontend Developer, specializing in React.js.",
    imageUrl: photoReactjs,
    location: "Work From Home",
  },
  {
    year: "2021/09 - 2023/06",
    description:
      "Worked at Pyrotech Design as a Web Developer, primarily using WordPress.",
    imageUrl: pyrotech,
    location: "70 Light Square, Adelaide",
  },
  {
    year: "2016-2019",
    description: "Adapted to the new environment, started working.",
    imageUrl: kitchen,
    location: "Star Of Siam",
  },
  {
    year: "2015",
    description:
      "Arrived in Adelaide, faced challenges with language and culture.",
    imageUrl: adelaide,
    location: "Adelaide",
  },
];

export default function TimeLine() {
  return (
    <div>
      {/* Heading Section */}
      <HeadingSection />
      {/* Timeline Section */}
      <TimelineSection events={timelineEvents} />
    </div>
  );
}

// Reusable Heading Section Component
const HeadingSection = () => (
  <div className="relative">
    <div className="relative">
      <img
        alt=""
        src={techPhoto}
        className="h-32 w-full object-cover lg:h-60 filter brightness-50"
      />
      <h1 className="absolute inset-0 flex items-center justify-center text-brand-gray font-bold text-xl sm:mb-0 mb-2 sm:text-4xl z-10">
        My Journey in Adelaide
      </h1>
    </div>
    <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
      <div className="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
        <div className="flex">
          <img
            alt=""
            src={matt1}
            className="h-24 w-24 lg:h-35 lg:w-35 rounded-full ring-4 ring-white sm:h-24 sm:w-24 object-cover"
          />
        </div>
        <div className="mt-6 sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
          <div className="mt-6 min-w-0 flex-1 sm:hidden md:block">
            <h1 className="truncate text-2xl font-bold text-gray-900">Matt Liang</h1>
          </div>
          <ContactButtons />
        </div>
      </div>
      <div className="mt-6 hidden min-w-0 flex-1 sm:block md:hidden">
        <h1 className="truncate text-2xl font-bold text-gray-900">Matt Liang</h1>
      </div>
    </div>
  </div>
);

// Reusable Contact Buttons Component
const ContactButtons = () => (
  <div className="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">
    <button
      type="button"
      className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
    >
      <EnvelopeIcon
        aria-hidden="true"
        className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400"
      />
      <a href="mailto:leungkeno@gmail.com">
      <span>Message</span>
      </a>
    </button>
    {/* <button
      type="button"
      className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
    >
      <PhoneIcon
        aria-hidden="true"
        className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400"
      />
      <span>Call</span>
    </button> */}
  </div>
);

// Reusable Timeline Section Component
const TimelineSection = ({ events }) => (
  <div>
    {events.map((event, index) => (
      <TimelineEvent key={index} event={event} />
    ))}
  </div>
);

// Reusable Timeline Event Component
const TimelineEvent = ({ event }) => (
  <div className="bg-white pb-16 pt-24 sm:pb-24 sm:pt-32 xl:pb-32">
    <div className="bg-gray-900 pb-20 sm:pb-24 xl:pb-0">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-x-8 gap-y-10 px-6 sm:gap-y-8 lg:px-8 xl:flex-row xl:items-stretch">
        <div className="-mt-8 w-full max-w-2xl xl:-mb-8 xl:w-full xl:flex-none">
          <div className="relative aspect-[2/1] h-full md:-mx-8 xl:mx-0 xl:aspect-auto">
            <img
              alt={event.imageUrl}
              src={event.imageUrl}
              className="absolute inset-0 h-full w-full rounded-2xl bg-gray-800 object-cover shadow-2xl myAnimation"
            />
          </div>
        </div>
        <div className="w-full max-w-2xl xl:max-w-none xl:flex-auto xl:px-16 xl:py-24">
          <figure className="relative isolate pt-6 sm:pt-12">
            <svg
              fill="none"
              viewBox="0 0 162 128"
              aria-hidden="true"
              className="absolute left-0 top-0 -z-10 h-32 stroke-white/20"
            >
              <path
                d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"
                id="b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb"
              />
              <use
                x={86}
                href="#b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb"
              />
            </svg>
            <blockquote className="text-xl font-semibold leading-8 text-white sm:text-2xl sm:leading-9">
              <p>{event.description}</p>
            </blockquote>
            <figcaption className="mt-8 text-base">
              <div className="font-semibold text-white">
                Location: <span>{event.location}</span>
              </div>
              <div className="mt-1 text-gray-400">
                <span>Time: {event.year}</span>
              </div>
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
);
